import React from 'react';
import cn from 'classnames';
import uniqueId from 'uniqid';
import Link from '../Link';

const ns = 'rich-text-shopify';

const TextParser = ({ item }) => {
	const { children, type, value, level, bold, italic, url } = item;
	const textMarkup = (
		<div
			className={cn({
				[`h${level}`]: level,
				[`font-bold`]: bold,
				[`italic`]: italic,
			})}
		>
			{value}
		</div>
	);

	return type === `link` ? (
		<Link href={url}>
			{children?.map((child) => {
				return (
					<TextParser
						item={child}
						// eslint-disable-next-line react/no-array-index-key
						key={uniqueId('link-item')}
					/>
				);
			})}
		</Link>
	) : (
		textMarkup
	);
};

export default function RichTextShopify({ fieldData, fieldName }) {
	const parsedData = fieldData && JSON.parse(fieldData);

	if (!parsedData) return null;

	const rootClassnames = cn(`${ns}`, {
		[`${ns}__${fieldName}`]: fieldName,
	});

	return (
		<div className={rootClassnames}>
			{parsedData?.children?.map(({ type, children, level }) => {
				return (
					<div key={uniqueId('rich-text-shopify')}>
						{/* paragraph or header type render */}
						{(type === `paragraph` || type === `heading`) && (
							<div className={`${ns}__text`}>
								<span>
									{children?.map((item) => {
										return (
											<TextParser
												item={{ level, ...item }}
												// eslint-disable-next-line react/no-array-index-key
												key={uniqueId('list-subitem')}
											/>
										);
									})}
								</span>
							</div>
						)}

						{/* list type render */}
						{type === `list` && (
							<ul className={`${ns}__list`}>
								{children?.map((listItem) => {
									if (listItem?.type !== `list-item`) return null;

									return (
										<li
											className={`${ns}__list-item`}
											// eslint-disable-next-line react/no-array-index-key
											key={uniqueId('list-item')}
										>
											<span>
												{listItem?.children?.map((listSubItem) => {
													return (
														<TextParser
															item={listSubItem}
															// eslint-disable-next-line react/no-array-index-key
															key={uniqueId('list-subitem')}
														/>
													);
												})}
											</span>
										</li>
									);
								})}
							</ul>
						)}
					</div>
				);
			})}
		</div>
	);
}
